export const resolvePopUpDegree = (row?: unknown): string => {
  if (!row || typeof row !== "object") return "";
  const record = row as Record<string, unknown>;
  return String(record.levelEducation ?? record.level_education ?? "").trim();
};
